import PropTypes from 'prop-types'
import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { logout } from '../../actions/auth'
import config from '../../config'
import { ordenarMenu } from '../../helpers/funciones'
import i18n from '../../lang/idiomas'

export class Footer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    portal: PropTypes.object.isRequired,
    menus: PropTypes.array.isRequired,
  }

  render() {
    const { isAuthenticated } = this.props.auth
    let menus = this.props.menus
    const invitado = this.props.auth.invitado

    if (menus && menus.length > 0) {
      menus.sort(ordenarMenu)
      if (this.props.auth.isAuthenticated && !invitado) {
        menus = menus.filter(menu => {
          return menu.programa !== 'login' && menu.programa !== 'registro'
        })
      }
      if (this.props.auth.user !== null && this.props.auth.user.puede_crear_usuarios !== 'S') {
        menus = menus.filter(menu => {
          return menu.programa !== 'registroHijos'
        })
      }
    }
    // const enlaces_disponibles = (
    //   <Fragment>
    //     {menus && menus.length > 0
    //       ? menus.map(menu => {
    //           menu.hijos.sort(ordenarMenu)
    //           return menu.visible === 'S' &&
    //             menu.nombre !== 'CARRITO' &&
    //             menu.nombre !== 'USUARIO' &&
    //             menu.nombre !== 'SELECTOR_CLIENTE' &&
    //             menu.nombre !== 'Selector permiso' ? (
    //             <Fragment key={menu.id}>
    //               {menu.hijos.length > 0 ? (
    //                 <Fragment>
    //                   {menu.hijos.map(hijo => {
    //                     return hijo.visible === 'S' ? (
    //                       <li key={hijo.id}>
    //                         {/* <Link to={"/" + hijo.programa + (hijo.camino ? "/" + hijo.camino : "")}>{hijo.nombre}</Link> */}
    //                         <Link
    //                           to={
    //                             (hijo.programa.toUpperCase().startsWith('HTTP')
    //                               ? hijo.programa
    //                               : '/' + hijo.programa) + (hijo.camino ? '/' + hijo.camino : '')
    //                           }>
    //                           {hijo.nombre}
    //                         </Link>
    //                       </li>
    //                     ) : (
    //                       ''
    //                     )
    //                   })}
    //                 </Fragment>
    //               ) : (
    //                 <li key={menu.id}>
    //                   <Link to={'/' + menu.programa + (menu.camino ? '/' + menu.camino : '')}>
    //                     {menu.nombre}
    //                   </Link>
    //                 </li>
    //               )}
    //             </Fragment>
    //           ) : (
    //             ''
    //           )
    //         })
    //       : ''}
    //     <li key={'configCookies'}>
    //       <Link to={'/configurarCookies'}>{i18n.t('layout.lconfcoo')}</Link>
    //     </li>
    //   </Fragment>
    // )

    const contenido = (
      <footer className='site-footer'>
        <div className='container'>
          <div className='row'>
            {/* Columna 1: Logo + info + links legales */}
            <div className='col-md-6 footer-col'>
              <Link to='/'>
                <img
                  className='footer-logo'
                  src='/assets/img/logo-footer.png'
                  alt='Casals Footer Logo'
                />
              </Link>
              <h5 className='footer-title'>CASALS MATERIAL INDUSTRIAL S.L.</h5>
              <p className='footer-text'>
                Especializados en la comercialización de piezas de recambio para Vehículos
                Industriales.
              </p>
            </div>

            {/* Columna 2: Contacto */}
            <div className='col-md-6 footer-col'>
              <h5 className='footer-title'>{i18n.t('layout.lcontact')}</h5>
              {config.contacto.direccion !== '' && (
                <p className='footer-text'>{config.contacto.direccion}</p>
              )}
              <hr className='footer-divider' />
              {config.contacto.telefono !== '' && (
                <p className='footer-text'>
                  <i className='fas fa-phone footer-contact-icon' />
                  {i18n.t('layout.ltel')}: {i18n.t('layout.cas_telf')}
                </p>
              )}
              {config.contacto.whatsapp && config.contacto.whatsapp !== '' && (
                <p className='footer-text'>
                  <a
                    href={`https://wa.me/34689600433`}
                    target='_blank'
                    rel='noopener noreferrer'>
                    <i className='fab fa-whatsapp footer-contact-icon' />
                    {i18n.t('layout.lwhatsap')}: {config.contacto.whatsapp}
                  </a>
                </p>
              )}
            </div>
          </div>

          <hr className='footer-divider' />

          <div className='footer-bottom'>
            <ul className='footer-links'>
              <li>
                <a
                  href='https://casalsmd.com/aviso-legal/'
                  target='_blank'
                  rel='noopener noreferrer'>
                  {i18n.t('layout.lavleg')}
                </a>
              </li>
              <li>
                <a
                  href='https://casalsmd.com/politica-de-privacidad/'
                  target='_blank'
                  rel='noopener noreferrer'>
                  {i18n.t('layout.lpolpri')}
                </a>
              </li>
              <li>
                <a
                  href='https://casalsmd.com/politica-de-cookies/'
                  target='_blank'
                  rel='noopener noreferrer'>
                  {i18n.t('layout.lconfcoo')}
                </a>
              </li>
            </ul>
            <p className='footer-copy'>
              &copy;{' '}
              {config.copyright !== ''
                ? config.copyright + '  ' + new Date().getFullYear()
                : 'Edisa  ' + new Date().getFullYear()}
              {'.'} Casals Material Industrial {/* Todos los derechos reservados. */}
            </p>
          </div>
        </div>
      </footer>
    )

    return (
      <Fragment>{config.footer.publico ? contenido : isAuthenticated ? contenido : ''}</Fragment>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  portal: state.portal.portal,
  menus: state.portal.menus,
})

export default connect(mapStateToProps, { logout })(Footer)
